import { render, staticRenderFns } from "./vip-favi.vue?vue&type=template&id=f931f39a&scoped=true&"
import script from "./vip-favi.vue?vue&type=script&lang=js&"
export * from "./vip-favi.vue?vue&type=script&lang=js&"
import style0 from "./vip-favi.vue?vue&type=style&index=0&id=f931f39a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f931f39a",
  null
  
)

export default component.exports